module.exports = __webpack_public_path__ + "static/media/snuffer.166d0920.jpg";